/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Rental_Booking_Status_CancelledInputs */

const en_rental_booking_status_cancelled = /** @type {(inputs: Rental_Booking_Status_CancelledInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cancelled`)
};

const es_rental_booking_status_cancelled = /** @type {(inputs: Rental_Booking_Status_CancelledInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cancelada`)
};

const fr_rental_booking_status_cancelled = /** @type {(inputs: Rental_Booking_Status_CancelledInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Annulé`)
};

const de_rental_booking_status_cancelled = /** @type {(inputs: Rental_Booking_Status_CancelledInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Storniert`)
};

const id_rental_booking_status_cancelled = /** @type {(inputs: Rental_Booking_Status_CancelledInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dibatalkan`)
};

/** @type {(inputs: Rental_Booking_Status_CancelledInputs) => LocalizedString} */
const ja_rental_booking_status_cancelled = en_rental_booking_status_cancelled;

/** @type {(inputs: Rental_Booking_Status_CancelledInputs) => LocalizedString} */
const zh_rental_booking_status_cancelled = en_rental_booking_status_cancelled;

/** @type {(inputs: Rental_Booking_Status_CancelledInputs) => LocalizedString} */
const ar_rental_booking_status_cancelled = en_rental_booking_status_cancelled;

/** @type {(inputs: Rental_Booking_Status_CancelledInputs) => LocalizedString} */
const it_rental_booking_status_cancelled = en_rental_booking_status_cancelled;

/** @type {(inputs: Rental_Booking_Status_CancelledInputs) => LocalizedString} */
const ru_rental_booking_status_cancelled = en_rental_booking_status_cancelled;

/** @type {(inputs: Rental_Booking_Status_CancelledInputs) => LocalizedString} */
const pt_rental_booking_status_cancelled = en_rental_booking_status_cancelled;

/** @type {(inputs: Rental_Booking_Status_CancelledInputs) => LocalizedString} */
const ko_rental_booking_status_cancelled = en_rental_booking_status_cancelled;

/**
* | output |
* | --- |
* | "Cancelled" |
*
* @param {Rental_Booking_Status_CancelledInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const rental_booking_status_cancelled = /** @type {((inputs?: Rental_Booking_Status_CancelledInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Rental_Booking_Status_CancelledInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_rental_booking_status_cancelled(inputs)
	if (locale === "es") return es_rental_booking_status_cancelled(inputs)
	if (locale === "fr") return fr_rental_booking_status_cancelled(inputs)
	if (locale === "de") return de_rental_booking_status_cancelled(inputs)
	if (locale === "ja") return ja_rental_booking_status_cancelled(inputs)
	if (locale === "zh") return zh_rental_booking_status_cancelled(inputs)
	if (locale === "ar") return ar_rental_booking_status_cancelled(inputs)
	if (locale === "id") return id_rental_booking_status_cancelled(inputs)
	if (locale === "it") return it_rental_booking_status_cancelled(inputs)
	if (locale === "ru") return ru_rental_booking_status_cancelled(inputs)
	if (locale === "pt") return pt_rental_booking_status_cancelled(inputs)
	return ko_rental_booking_status_cancelled(inputs)
});